import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';

import { renderFormField } from 'modules/form';
import { studentUpgradeV2Fields } from 'constants/form';
import { Row } from '@cuemath/comps';
import BallLoader from 'comps/ball-loader';
import StudentTrialUpgradeForm from './trial-upgrade';
import {
  post as studentCourseUpgradeV2,
  emptyStoreData,
} from 'actions/student-course-upgrade-v2';
import { closeModal } from 'actions/modal';
import CopyButton from '../../comps/copy-button';
import { Message } from 'modules/form';
import { EVENT_TYPE } from 'constants/logger';
import { trackEvent } from 'modules/analytics';
import { Separator, Text } from '@cuemath/web-comps';

const Wrapper = styled.div`
  padding: 40px 10px 20px;
`;

const CopyButtonWrapper = styled.div`
  width: 300px;
`;

const CopyButtonText = styled.div`
  width: 28%;
  padding-left: 10px;
`;

const StudentUpgradeForm = ({ studentCourseUpgradeV2, studentCourse, actions }) => {
  const [form, setForm] = useState(getFormDefaults());
  const [fields] = useState(studentUpgradeV2Fields);
  const [error, setError] = useState(null);

  const {
    id: studentCourseId,
    student_id: studentId,
    state: courseState,
    enrollment_type: enrollmentType,
    course_name: courseName,
    course_id: courseId,
    classes_balance: balance,
  } = studentCourse || {};

  const studentCourseUpgradeV2PostData = store.post(
    studentCourseUpgradeV2,
    studentCourseId,
  );

  const { resolved: postDataResolved } = studentCourseUpgradeV2PostData || {};
  const { data: postData, isCreated, isCreatingFailed, isCreating } =
    postDataResolved || {};
  const { upgrade_details: upgradeDetails, renewal_plans: plans } = postData || {};
  const { state, transition_details: transitionDetails, id: upgradeId } =
    upgradeDetails || {};
  const { currency_symbol: currencySymbol } = (plans && plans.length && plans[0]) || {};
  const { amount, total_classes: classesLeft } = transitionDetails || {};
  console.log({ postDataResolved });
  const fillForm = () => {
    if (amount === undefined || classesLeft === undefined) return;

    let newForm = {};
    newForm.unused_balance = (currencySymbol || '') + ' ' + amount.toString();
    newForm.classes_left = classesLeft.toString();
    setForm({ ...form, ...newForm });
  };

  const trackEventFunc = modalType => {
    trackEvent(EVENT_TYPE.TRIAL_UPGRADE_MODAL_VIEW, {
      modal_view: modalType,
      student_id: studentId,
      enrollment_type: enrollmentType,
      course_name: courseName,
      course_id: courseId,
      class_balance: balance,
      course_state: courseState,
      transaction_id: upgradeId,
    });
  };

  useEffect(() => {
    const postData = {
      action: 'get_or_create_upgrade_v2',
      action_data: { to_enrollment_type: 'PLUS' },
    };
    actions.studentCourseUpgradeV2(studentCourseId, postData);
    return () => {
      actions.emptyStoreData({ items: {} });
    };
  }, []);

  useEffect(() => {
    if (isCreated) {
      fillForm();
      trackEventFunc('upgrade_v2');
    } else if (isCreatingFailed) {
      setError(true);
    }
  }, [isCreated, isCreatingFailed]);

  function getFormDefaults() {
    const formDefaults = {};

    studentUpgradeV2Fields.forEach(field => {
      formDefaults[field.name] = field.default;
    });
    return formDefaults;
  }

  if (isCreating || !postDataResolved) {
    return (
      <>
        <Separator height={32} />
        <Row justifyContent="center" alignItems="center">
          <BallLoader />
        </Row>
      </>
    );
  }

  if (error) {
    return (
      <StudentTrialUpgradeForm
        studentCourse={studentCourse}
        trackEventFunc={trackEventFunc}
      />
    );
  }

  if (state === 'PAID') {
    return (
      <Wrapper>
        <Message width="100%" error>
          Already upgraded to PLUS program
        </Message>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {fields &&
        fields.map(field =>
          renderFormField({
            ...field,
            value: form[field.name],
          }),
        )}
      <Row alignItems="center">
        <CopyButtonText>
          <Text variant="body1regular">PLUS Upgrade Link</Text>
        </CopyButtonText>
        <CopyButtonWrapper>
          <CopyButton
            style={{ width: '300' }}
            copyMessage="Upgrade Link"
            text={`https://www.cuemath.com/student/upgrade/${upgradeId}/?utm_source=la`}
          />
        </CopyButtonWrapper>
      </Row>
    </Wrapper>
  );
};

export default connect(
  ({ studentCourseUpgradeV2 }) => {
    return { studentCourseUpgradeV2 };
  },
  dispatch => ({
    actions: bindActionCreators(
      {
        studentCourseUpgradeV2,
        emptyStoreData,
        closeModal,
      },
      dispatch,
    ),
  }),
)(StudentUpgradeForm);
